import { isArray } from 'lodash';
import { onlyDigits } from '../utils';
export const numeric = (value) => {
    return onlyDigits(value) && !isArray(value);
};
